module.exports = __webpack_public_path__ + "img/bv.befbd62d.svg";